import React, { useState } from 'react';
import { signUp, confirmSignUp, signIn } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const SignUp = () => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [confirmationCode, setConfirmationCode] = useState('');
  const [isConfirming, setIsConfirming] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      await signUp({
        username: email, // Using email as the username
        password,
        options: {
          userAttributes: { email }
        }
      });
      setIsConfirming(true);
    } catch (err) {
      console.error('Sign up error:', err);
      setError(err.message || 'Failed to sign up');
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmation = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Confirm the sign up
      await confirmSignUp({
        username: email, // Using email as the username
        confirmationCode
      });

      // Automatically sign in after successful confirmation
      try {
        await signIn({ username: email, password });
        // Redirect to dashboard after successful login
        navigate('/dashboard');
      } catch (signInErr) {
        console.error('Auto sign-in error:', signInErr);
        // If auto sign-in fails, redirect to login page
        navigate('/login');
      }
    } catch (err) {
      console.error('Confirmation error:', err);
      setError(err.message || 'Failed to confirm sign up');
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Create RangeDat Account</h2>
      {error && <div className="error-message">{error}</div>}

      {!isConfirming ? (
        <form onSubmit={handleSignUp}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={loading}
              required
            />
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Signing Up...' : 'Sign Up'}
          </button>
        </form>
      ) : (
        <form onSubmit={handleConfirmation}>
          <div className="form-group">
            <label htmlFor="confirmationCode">Confirmation Code</label>
            <input
              type="text"
              id="confirmationCode"
              value={confirmationCode}
              onChange={(e) => setConfirmationCode(e.target.value)}
              disabled={loading}
              required
            />
            <small>Please check your email for the confirmation code</small>
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Confirming...' : 'Confirm'}
          </button>
        </form>
      )}

      <div className="auth-links">
        <p>
          Already have an account? <span onClick={() => navigate('/login')}>Login</span>
        </p>
      </div>
    </div>
  );
};

export default SignUp;

